import { AppSize, pxToRem, AppLinks } from "@/util";
import { Box } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Header from "./header";
import ServiceCard from "./serviceCard";

export default function OurServices() {
  const { classes } = styles();
  return (
    <Box className={classes.container}>
      <Header
        name={"Our Services"}
        isAction={true}
        action={"View all Services"}
        nav={AppLinks.PUBLIC.SERVICES}
        description={
          "At Arel, we provide top-tier real estate solutions, from construction to investment opportunities, ensuring quality and client satisfaction"
        }
      />
      <Box className={classes.sub}>
        <Box className={classes.subCard}>
          <ServiceCard
            img="/images/home/real estate solutions.svg"
            name="Real Estate Investment Solutions"
            desc={
              "We offer secure and profitable real estate investment opportunities with high ROI"
            }
          />
          <ServiceCard
            isReverse
            img="/images/home/Architectural_Design.png"
            name="Architectural Design & Planning"
            desc="Our expert architects create innovative and functional property designs tailored to modern living"
          />
        </Box>
        <Box className={classes.subCard2}>
          <ServiceCard
            img="/images/home/construction and management image.svg"
            name="Construction & Project Management"
            desc="We oversee real estate development from start to finish, ensuring efficiency, durability, and top-quality standards"
          />
          <ServiceCard
            isReverse
            img="/images/home/Interior design.svg"
            name="Interior Design & Fixtures Production"
            desc="We bring spaces to life with bespoke interior designs, customized furnishings, and aesthetic
            finishing"
          />
        </Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    minHeight: pxToRem(1200),
    display: "flex",
    flexDirection: "column",
    padding: `${theme.spacing(4)} ${pxToRem(AppSize.padding)}`,
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(4)} ${pxToRem(30)}`,
    },
  },
  sub: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    minHeight: pxToRem(500),
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {},
  },
  subCard: {
    display: "grid",
    gridTemplateColumns: "3fr 1.8fr",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(4),
    },
  },
  subCard2: {
    display: "grid",
    gridTemplateColumns: "1.8fr 3fr",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
}));
